/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Search_Status_UnsupportedInputs */



/**
* | output |
* | --- |
* | "Unsupported" |
*
* @param {Spaces_Search_Status_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_search_status_unsupported = /** @type {((inputs?: Spaces_Search_Status_UnsupportedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Search_Status_UnsupportedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht unterstützt")
	return /** @type {LocalizedString} */ ("Unsupported")
});